import { type ReactElement } from 'react'
import { Burger, Group } from '@mantine/core'
import { MobileHeaderSearchButton, UniversalSearchModal } from '../universalSearch'
import { NotificationBell } from '../../notifications/NotificationBell'
import { TerrosHeaderLogo } from './TerrosLogo'

type ShellHeaderBarProps = {
  burgerOpen: boolean
  toggleBurger: VoidFunction
}

export const ShellHeaderBar = ({ burgerOpen, toggleBurger }: ShellHeaderBarProps): ReactElement => {
  return (
    <div className='flex h-full flex-row items-center justify-evenly'>
      <div className='flex-1'>
        <TerrosHeaderLogo />
      </div>
      <Group flex={1} justify='center' visibleFrom='xs'>
        <UniversalSearchModal />
      </Group>
      <Group flex={1} justify='flex-end' gap='xs' wrap='nowrap' pr='md'>
        <MobileHeaderSearchButton onBeforeOpen={burgerOpen ? toggleBurger : undefined} />
        <NotificationBell />
        <Burger color='white' opened={burgerOpen} size='sm' hiddenFrom='sm' onClick={toggleBurger} />
      </Group>
    </div>
  )
}
